import { AuthRepository } from '../../domain/repository';
import { AuthRepositoryImpl } from '../repository';

export const authProviders = [
  {
    provide: AuthRepository,
    useExisting: AuthRepositoryImpl,
  },
];


